import type { Uuid } from '@shared/api';

export type LeadStatus = 'NEW' | 'IN_TOUCH' | 'QUOTED' | 'WON' | 'LOST';

export type LeadSource = 'RFQ_TARGET' | 'QUOTE' | 'ORDER' | 'MANUAL';

export interface Lead {
  id: Uuid;
  manufacturerId: Uuid;
  buyerId: Uuid | null;
  title: string;
  notes: string | null;
  status: LeadStatus;
  source: LeadSource;
  sourceRefId: Uuid | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateLeadRequest {
  buyerId?: Uuid | null;
  title: string;
  notes?: string | null;
}

export const LEAD_STATUSES: LeadStatus[] = ['NEW', 'IN_TOUCH', 'QUOTED', 'WON', 'LOST'];

export const LEAD_STATUS_LABEL: Record<LeadStatus, string> = {
  NEW: 'New',
  IN_TOUCH: 'In touch',
  QUOTED: 'Quoted',
  WON: 'Won',
  LOST: 'Lost',
};

export const LEAD_SOURCE_LABEL: Record<LeadSource, string> = {
  RFQ_TARGET: 'RFQ target',
  QUOTE: 'Quote',
  ORDER: 'Order',
  MANUAL: 'Manual',
};
